// Build identity injected at build time by vite `define` (see vite.config.ts).
export const BUILD_SHA = __BUILD_SHA__;
export const BUILD_DATE = __BUILD_DATE__;
export const BUILD_VERSION = __APP_VERSION__;

// Greppable marker so we can confirm exactly which build is live in the served bundle.
// Keeps the recovered-UI tag for continuity, plus the app version + live commit sha + build date.
export const BUILD_MARKER = `FAD-LIVE-UI v${BUILD_VERSION} ${BUILD_SHA} · ${BUILD_DATE}`;
